<template>
  <div ref="OneCopyTemp" class="d-none">
    <div v-html="EjsData"></div>
    <!-- <div
      v-if="ticketDetails.length > 0"
      v-for="(item, itemIndex) in bookingDetails.seats_types"
      :key="itemIndex"
      :style="{ 'margin-bottom': '100px' }"
    >
      <table
        v-if="ticketDetails[0].tt_single_seat_ticket == 'Y'"
        v-for="(x , xk) in ticketDetails[0].tt_no_of_copy"
        :key="xk"
        style="width:300px;border:1px solid #000;font-size:12px;"
      >
        <tr>
          <td colspan="4" style="text-align:center;padding-top:20px;">
            <strong
              v-if="ticketDetails[0].tt_show_cinema_name == 'Y'"
            >{{bookingDetails.cine_name}} - {{bookingDetails.cine_address}}</strong>
            <p v-if="ticketDetails[0].tt_show_address == 'Y'">{{bookingDetails.cine_address}}</p>
          </td>
        </tr>

        <tr>
          <td colspan="4" style="padding-bottom:15px;">
            <table style="width:100%;text-align:center;">
              <tr>
                <td style="width:33.33%">
                  <p style="margin:0;">Transaction Id</p>
                  <strong>{{ bookingDetails.sb_booking_code }}</strong>
                </td>
                <td v-if="ticketDetails[0].tt_show_date_time == 'Y'" style="width:33.33%">
                  <p style="margin:0;">Date</p>
                  <strong>{{ bookingDetails.og_show_date | dayonly3 }}, {{ bookingDetails.og_show_date | dateparse }}</strong>
                </td>
                <td v-if="ticketDetails[0].tt_show_date_time == 'Y'" style="width:33.33%">
                  <p style="margin:0;">Time</p>
                  <strong>{{ bookingDetails.og_show_time | timeparseAmPm }}</strong>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td colspan="4" style="padding-bottom:15px;">
            <table style="width:100%;">
              <tr>
                <td style="width:70%;padding: 0 5px;">
                  <p style="margin:0;">Movie</p>
                  <strong>{{ bookingDetails.movie_title }}</strong>
                </td>
                <td
                  v-if="ticketDetails[0].tt_show_screen_name == 'Y'"
                  style="width:30%;padding: 0 5px;"
                >
                  <p style="margin:0;">Screen</p>
                  <strong>{{bookingDetails.screen_name}}</strong>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr v-if="ticketDetails[0].tt_show_charge_details == 'Y'" style="text-align:center;">
          <td colspan="2" style="width:25%;padding-bottom: 15px;">
            <p style="margin:0;">Restriction</p>
            <strong>{{bookingDetails.rating}}</strong>
          </td>
          <td style="width:25%;padding-bottom: 15px;">
            <p style="margin:0;">Ticket</p>
            <strong>{{ item.seatPrice.toFixed() }}</strong>
          </td>
          <td
            v-if="ticketDetails[0].tt_show_charge_details == 'Y'"
            style="width:25%;padding-bottom: 15px;"
          >
            <p style="margin:0;">VAT</p>
            <strong>00</strong>
          </td>
          <td style="width:25%;padding-bottom: 15px;">
            <p style="margin:0;">Total</p>
            <strong>{{ item.seatPrice.toFixed() }}</strong>
          </td>
        </tr>

        <tr v-else style="text-align:center;">
          <td style="width:25%;padding-bottom: 15px;">
            <p style="margin:0;">Restriction</p>
            <strong>{{bookingDetails.rating}}</strong>
          </td>
          <td style="width:25%;padding-bottom: 15px;">
            <p style="margin:0;">Ticket</p>
            <strong>{{ item.seatPrice.toFixed() }}</strong>
          </td>
          <td style="width:25%;padding-bottom: 15px;">
            <p style="margin:0;">VAT</p>
            <strong>00</strong>
          </td>
          <td style="width:25%;padding-bottom: 15px;">
            <p style="margin:0;">Total</p>
            <strong>{{ item.seatPrice.toFixed() }}</strong>
          </td>
        </tr>

        <tr>
          <td colspan="4" style="padding-bottom:20px;">
            <table style="width:100%;">
              <tr>
                <td v-if="ticketDetails[0].tt_show_seat_type == 'Y'" style="padding: 0 5px;">
                  <span style="margin:0;">Class:</span>
                  <strong>{{ item.seatType.toUpperCase() }}</strong>
                </td>
                <td v-if="ticketDetails[0].tt_show_seat_name == 'Y'" style="padding: 0 5px;">
                  <span style="margin:0;">Seats:</span>
                  <strong>{{ item.seatName }}</strong>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>-->
  </div>
</template>

<script>
import Printd from "printd";

import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosService from "@/services/PosService";
import moment from "moment";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    ticketDetails: {
      type: Array
    }
  },
  data() {
    return {
      EjsData: null
    };
  },
  computed: {
    isReprint() {
      return this.$store.getters.isReprint;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    getSelectedArray() {
      let array = [];
      if (
        this.bookingDetails &&
        this.bookingDetails["seats_types"] &&
        this.bookingDetails["seats_types"].length > 0
      ) {
        this.bookingDetails.seats_types.map(x => {
          x.seats.map(y => {
            array.push({
              seatName: y,
              seatType: x.seat_type
            });
          });
        });
      }
      return array;
    },
    ...mapGetters(["IDforBoxOfficeEjs"])
  },
  mounted() {
    EventBus.$on("printOneCopyTemp", data => {
      // this.print();
      this.GetEjsTicket();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printDefaultTemp");
  },
  methods: {
    GetEjsTicket: function() {
      let loader = this.$loading.show();

      PosService.GetTicketEjs(
        this.IDforBoxOfficeEjs.sb_id,
        this.IDforBoxOfficeEjs.cinema_id,
        this.isReprint
      )
        .then(response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.OneCopyTemp) {
        p.print(this.$refs.OneCopyTemp, []);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/PrintTicketTemplates/One_Copy_Template.vue